import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  proLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Roboto !important',
    lineHeight: 'normal',
    width: '34px',
    height: '15px',
    fontSize: '10px !important',
    background: colors.primary,
    color: `${colors.white} !important`,
    borderRadius: '2px',
  },
}));

const ProLabel = ({ className }) => {
  const classes = useStyles();
  return <span className={classnames(classes.proLabel, className)}>PRO</span>;
};

ProLabel.propTypes = {
  className: PropTypes.string,
};

ProLabel.defaultProps = {
  className: '',
};

export default ProLabel;
